// extracted by mini-css-extract-plugin
export default {"footerlogo":"footer_footerlogo__rS91n","footeradress":"footer_footeradress__eKHUG","footernav":"footer_footernav__msMZZ"};